import "../pages.scss"
import { InventariosCabState } from '../../context/inventariosCab/InventariosCabState';
import Datatable from "./inventariosCabTable/Datatable"

const InventariosCabPage = () => {
  return (
    <>
      <InventariosCabState>
        <Datatable />
      </InventariosCabState>

    </>
  )
}

export default InventariosCabPage